/**
 * Application entry point
 * @author Maheen Nasir
 * @description Initializes the React application and renders the root component
 */

import { bootstrapTheme } from "@config/theme/apply-css-variables";

bootstrapTheme();

import "./polyfills";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./config/sentry.client.config";
import "./i18n";

/**
 * Creates and renders the root React component
 * @description Mounts the application to the DOM with strict mode enabled
 */
ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);
